import { executeRequest, Request } from '@jfs/network'
import { GetAllBanksForIfsc } from './../network/parsers/GetAllBanksForIfsc'
import { APIEndPoints } from './APIEndpoints'
import { sitConfigWithAuthCred } from './config'

const responseParser = (data: any) => {
  const respData = GetAllBanksForIfsc(data?.response ?? [])
  return respData
}

const fetchAllBanks = (tokens: any, userAccessToken: string, mobile: string) => {
  const request: Request<{}> = {
    config: sitConfigWithAuthCred(tokens, mobile),
    apiPath: APIEndPoints.fetchbanksList,
    method: 'GET',
    cache: false,
    headers: {
      Authorization: userAccessToken,
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { fetchAllBanks }
